import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-536" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-537" data-mp="3ggk8mvu5ve02">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-538" data-mp="36pfutzg81z6t">
          <img src="https://cdn.magicpatterns.com/uploads/vBy52qowPNFNY53vkUADE7/SyNeural-logo-no-tagline-half-size.svg" alt="SyNeural" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-539" data-mp="36qhhl16loa4d" />
          <p className="text-sm leading-relaxed" data-id="element-540" data-mp="37xvkgeim0i0">
            Building intelligence in the world.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-541" data-mp="3qcx8kbgauo39">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-542" data-mp="3qcdu54puyhtz">
            Products
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-543" data-mp="2a19tpmiidoxa">
            <li data-id="element-544" data-mp="2eyt8qon165qa">
              <a href="/human-capability" className="hover:text-white transition-colors" data-id="element-545" data-mp="2ezb9nykn184j">
                Human Capability Platform
              </a>
            </li>
            <li data-id="element-546" data-mp="3gc0ftfnsvm5i">
              <a href="/cji" className="hover:text-white transition-colors pl-3" data-id="element-547" data-mp="3gcaa3ffvofh0">
                CJI
              </a>
            </li>
            <li data-id="element-548" data-mp="3q8wq9qx9eicp">
              <a href="/ncji" className="hover:text-white transition-colors pl-3" data-id="element-549" data-mp="3q8dih31bpace">
                NCJI
              </a>
            </li>
            <li data-id="element-550" data-mp="817cu4ckvmt0">
              <a href="/semantic-knowledge" className="hover:text-white transition-colors" data-id="element-551" data-mp="80nrsermsiar">
                Semantic Knowledge Platform
              </a>
            </li>
            <li data-id="element-552" data-mp="cu0fmmohkl2g">
              <a href="/llm-vs-skp" className="hover:text-white transition-colors pl-3" data-id="element-553" data-mp="ctgwx3r0hsnd">
                LLM vs. SKP
              </a>
            </li>
            <li data-id="element-554" data-mp="qrfai6xidl1t">
              <a href="/solutions" className="hover:text-white transition-colors" data-id="element-555" data-mp="mrwplb5ot9yz">
                Solutions
              </a>
            </li>

          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-556" data-mp="yv93jr68lwup">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-557" data-mp="yupkg74up2f3">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-558" data-mp="18k0qfkwfxqyr">
            <li data-id="element-559" data-mp="18l2c0jb31vuq">
              <a href="/education" className="hover:text-white transition-colors" data-id="element-560" data-mp="18lkbdot1kq6v">
                Education
              </a>
            </li>
            <li data-id="element-561" data-mp="1hje64vb5rbrx">
              <a href="/employers" className="hover:text-white transition-colors" data-id="element-562" data-mp="1hiumna5v0fbs">
                Employers
              </a>
            </li>
            <li data-id="element-563" data-mp="1rid49jyarp0o">
              <a href="/civil-society" className="hover:text-white transition-colors" data-id="element-564" data-mp="1rgsfyc2kt2b9">
                Civil Society
              </a>
            </li>
            <li data-id="element-565" data-mp="3tccdlzruzwaq">
              <a href="/government" className="hover:text-white transition-colors" data-id="element-566" data-mp="2af3sdp3431j3">
                Government
              </a>
            </li>
            <li data-id="element-567" data-mp="25mkh4yrwcihg">
              <a href="/leadership" className="hover:text-white transition-colors" data-id="element-568" data-mp="21mjy10turj42">
                Leadership
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-569" data-mp="2tdg3hgdl2lhb">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-570" data-mp="2tbvjgkowakxp">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-571" data-mp="2kd1gmckz0ybp">
            <li data-id="element-572" data-mp="2kbqai641zehf">
              <a href="/about" className="hover:text-white transition-colors" data-id="element-573" data-mp="2kfe5zat26ays">
                About
              </a>
            </li>
            <li data-id="element-574" data-mp="18xuz98g9rpvh">
              <a href="/research" className="hover:text-white transition-colors" data-id="element-575" data-mp="18yedae2stu48">
                Research
              </a>
            </li>
            <li data-id="element-576" data-mp="2rv7nvttzprz7">
              <a href="/roadmap" className="hover:text-white transition-colors" data-id="element-577" data-mp="2ruogv85vonzy">
                Roadmap
              </a>
            </li>
            <li data-id="element-578" data-mp="2ivud8xu4qxcw">
              <a href="/partnerships" className="hover:text-white transition-colors" data-id="element-579" data-mp="2iwciul2omnxh">
                Partnerships
              </a>
            </li>
            <li data-id="element-580" data-mp="3bkrx35dzp27r">
              <a href="/contact" className="hover:text-white transition-colors" data-id="element-581" data-mp="3bk8c1ft1lxpi">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-582" data-mp="31khj3ik4rqrj">
        <p data-id="element-583" data-mp="36mgnmvrlwtq2">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-584" data-mp="1q52mwgzqx2xh">
          <a href="/privacy" className="hover:text-white transition-colors" data-id="element-585" data-mp="1v574ybgay5pt">
            Privacy Policy
          </a>
          <a href="/terms" className="hover:text-white transition-colors" data-id="element-586" data-mp="1nl6ai1btrroq">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}